import MyProfilePopup from './MyProfilePopup';

export default MyProfilePopup;
